import { getMessages } from '../../../../../../store/constants';

export const CARD_DEFAULT_TEMPLATE = getMessages().getText('card_form_default_template');
